import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import RowView from '../RowView';

const TitleWithOption = ({ label, onRemovePress }) => {
  return (
    <RowView style={styles.container}>
      <BaseText style={CommonStyles.h3}>{label}</BaseText>
      {onRemovePress ? (<TouchableOpacity onPress={onRemovePress}>
        <BaseText style={{ ...CommonProperties.h3, color: Color.primary }}>Remove</BaseText>
      </TouchableOpacity>) : null}
    </RowView>
  );
};

export default TitleWithOption;

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
  },
});
